import './index.scss'
import Modal from 'react-modal'
import {useRef} from 'react'
import useOnClickOutside from '../../../utils/hooks/useOutsideClick'
import {ArrowLeftIcon, CloseIcon} from '../../../icons'
import classNames from 'classnames'
import {useSelector} from 'react-redux'
import {colors} from '../../../utils/colors'

const CustomModal = ({title, children, className, contentClassName, closeModal, backtoPreviousModal, isOpen, id, style = {}, hasBack = false}) => {
    const ref = useRef()
    const isDarkMode = useSelector(state => state.sidebar.isDarkMode)
    useOnClickOutside(ref, () => closeModal())

    return (
        <Modal overlayClassName={`modal ${className}`} className={classNames({
            'modal-content': true,
            'dark': isDarkMode,
            [contentClassName]: contentClassName
        })} id={id} ariaHideApp={false}
        shouldCloseOnEsc={true}
        style={{...style, height: window.innerHeight}}
        innerRef={ref} isOpen={isOpen} onRequestClose={closeModal}>
            <div className={classNames({
                'modal-header': true,
                'dark': isDarkMode
            })}>
                {hasBack && <span className="close d-flex back" onClick={backtoPreviousModal}>
                    <ArrowLeftIcon width={20} height={20} color={colors?.colorMuted}/>
                </span>}
                <h5>{title}</h5>
                <span className="close d-flex" onClick={closeModal}>
                    <CloseIcon/>
                </span>
            </div>
            {children}
        </Modal>
    )
}

export default CustomModal
